// DS2.1
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../PlainButtonOrLink';
import useIconSizeForButtonSize from '../hooks/useIconSizeForButtonSize';
import s from './SolidButton.scss';
const SolidButton = (_param)=>{
    var { size, variant, priority = 'primary', fillContainerWidth, className, children, icon: IconComponent, postfixIcon: PostFixIconComponent, loading } = _param, props = _object_without_properties(_param, [
        "size",
        "variant",
        "priority",
        "fillContainerWidth",
        "className",
        "children",
        "icon",
        "postfixIcon",
        "loading"
    ]);
    const iconSize = useIconSizeForButtonSize(size);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({
        className: classnames(className, s['root'], s[`variant-${variant}`], s[`priority-${priority}`], s[`size-${size}`], fillContainerWidth && s['fill-container-width'], props.disabled && s['disabled'], loading && s['loading'], IconComponent && s['with-prefix-icon'], PostFixIconComponent && s['with-postfix-icon'])
    }, props), IconComponent && /*#__PURE__*/ React.createElement(IconComponent, {
        className: s['icon'],
        size: iconSize,
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['content']
    }, children), PostFixIconComponent && /*#__PURE__*/ React.createElement(PostFixIconComponent, {
        className: s['icon'],
        size: iconSize,
        disableDefaultColors: true
    }));
};
SolidButton.displayName = 'SolidButton';
export default SolidButton;
